const Register = () => import('@/pages/auth/Register.vue')
const RegisterIndex = () => import('@/pages/auth/register/Index.vue')
const RegisterIndividual = () => import('@/pages/auth/register/Individual.vue')
const RegisterProfessional = () => import('@/pages/auth/register/Professional.vue')

export default [
    {
        path: '/enregistrement',
        name: 'register',
        component: Register,
        redirect: (/*to*/) => {
            return {name: 'register-index'}
        },
        meta: {
            title: "S'enregistrer",
            guard: 'guest-auth',
        },
        children: [
            {
                path: '',
                name: 'register-index',
                component: RegisterIndex,
                meta: {
                    title: 'S\'enregistrer',
                    guard: 'guest-auth',
                },
            },
            {
                path: 'stagiaire',
                name: 'register-individual',
                component: RegisterIndividual,
                meta: {
                    title: 'S\'enregistrer',
                    guard: 'guest-auth',
                },
            },
            {
                path: 'professionnel',
                name: 'register-professional',
                component: RegisterProfessional,
                meta: {
                    title: 'S\'enregistrer',
                    guard: 'guest-auth',
                },
            },
        ]
    },
]
